var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_5423)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_465_5423)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_465_5423)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_465_5423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4697 19.7751H3.48946C3.25398 19.7751 3.02814 19.6816 2.86162 19.515C2.69511 19.3485 2.60156 19.1227 2.60156 18.8872C2.60156 18.6517 2.69511 18.4259 2.86162 18.2594C3.02814 18.0929 3.25398 17.9993 3.48946 17.9993H19.4697C19.7052 17.9993 19.931 18.0929 20.0975 18.2594C20.264 18.4259 20.3576 18.6517 20.3576 18.8872C20.3576 19.1227 20.264 19.3485 20.0975 19.515C19.931 19.6816 19.7052 19.7751 19.4697 19.7751Z",
    fill: "#4B69F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4153 11.5623L10.8548 15.9568C10.9339 16.043 11.0299 16.1117 11.137 16.1588C11.244 16.2058 11.3596 16.2301 11.4765 16.2301C11.5934 16.2301 11.7091 16.2058 11.8161 16.1588C11.9231 16.1117 12.0192 16.043 12.0983 15.9568L16.5378 11.5623C16.6916 11.4051 16.785 11.1986 16.8012 10.9793C16.8175 10.7599 16.7557 10.5419 16.6267 10.3638C16.5548 10.2567 16.4593 10.1676 16.3476 10.1032C16.2359 10.0388 16.1109 10.0009 15.9823 9.99232C15.8537 9.98373 15.7248 10.0047 15.6055 10.0537C15.4862 10.1027 15.3798 10.1783 15.2943 10.2749L12.3649 13.2032V2.90499C12.3649 2.78839 12.342 2.67293 12.2973 2.56521C12.2527 2.45748 12.1873 2.3596 12.1049 2.27715C12.0224 2.1947 11.9245 2.1293 11.8168 2.08468C11.7091 2.04006 11.5936 2.01709 11.477 2.01709C11.3604 2.01709 11.245 2.04006 11.1372 2.08468C11.0295 2.1293 10.9316 2.1947 10.8492 2.27715C10.7667 2.3596 10.7013 2.45748 10.6567 2.56521C10.6121 2.67293 10.5891 2.78839 10.5891 2.90499V13.2032L7.65876 10.2729C7.57328 10.1763 7.46683 10.1007 7.34756 10.0517C7.2283 10.0027 7.09941 9.98174 6.97077 9.99032C6.84213 9.9989 6.71716 10.0368 6.60546 10.1012C6.49377 10.1656 6.39831 10.2547 6.32641 10.3618C6.19686 10.5401 6.13471 10.7585 6.15098 10.9783C6.16726 11.1981 6.26091 11.405 6.4153 11.5623Z",
    fill: "#4B69F1"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_5423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.824219 0.55127)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_465_5423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1200,
    fill: "white",
    transform: "translate(0.824219 0.55127)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_465_5423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.824219 0.55127)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_465_5423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.824219 0.55127)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a72021225b83b117648dad55466cdbbf.svg";
export { ForwardRef as ReactComponent };